import React from 'react';
import CompanyInfoPresenter from './CompanyInfoPresenter';

const CompanyInfoContainer: React.FunctionComponent = () => {
  return <CompanyInfoPresenter />;
};

export default CompanyInfoContainer;
